/** Fixed numeric phases, measured through the loader's actual interaction-unblock event. */
export function sceneReadyTiming(input: {
    navigationOffsetMs: number; responseStartMs: number; renderStartedAtMs: number; readyAtMs: number;
    history: readonly { phase: string; elapsedMs: number }[];
}) {
    const { navigationOffsetMs: offset, responseStartMs: response, renderStartedAtMs: render, readyAtMs: ready, history } = input;
    if (![offset, response, render, ready].every(Number.isFinite) || offset < 0 || response < 0 || render < response || ready < render || !history.length) return null;
    const detail: Record<string, number> = { total_ms: Math.round(offset + ready), shell_ms: Math.round(offset + response),
        prepare_ms: Math.round(offset + render) - Math.round(offset + response), renderer_ms: 0, terrain_ms: 0, environment_ms: 0,
        structures_ms: 0, placements_ms: 0, finalize_ms: 0, reveal_ms: 0 };
    const keyFor = (phase: string): string => phase === 'Preparing renderer' ? 'renderer_ms'
        : ['Preparing terrain', 'Preparing scenery', 'Loading terrain textures', 'Building terrain'].includes(phase) ? 'terrain_ms'
        : ['Loading environment assets', 'Building ground dressing', 'Environment ready'].includes(phase) ? 'environment_ms'
        : ['Building structures', 'Populating rooms'].includes(phase) ? 'structures_ms'
        : ['Hydrating interactive forest', 'Placing interactive assets'].includes(phase) ? 'placements_ms'
        : phase === 'Scene ready' ? 'reveal_ms' : 'finalize_ms';
    let at = render;
    // Repeated per-object progress entries belong to the same phase. Round boundaries, not intervals.
    for (let i = 0; i < history.length; i += 1) {
        const next = i + 1 < history.length ? Math.min(ready, Math.max(at, render + history[i + 1]!.elapsedMs)) : ready;
        if (!Number.isFinite(next)) return null;
        detail[keyFor(history[i]!.phase)]! += Math.round(offset + next) - Math.round(offset + at);
        at = next;
    }
    return { kind: 'slow' as const, reason: 'ready:ft3d_scene', client_ms: detail.total_ms!, detail };
}
